import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import {
  DepartmentCsvRowError,
  DepartmentCsvUploadResult,
} from '@/interfaces/model/general/department';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { formatDepartmentCsvRowError } from '@/utils/departmentCsv';
import { i18n } from '@/plugins/vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DepartmentCsvResultDialog',
  props: {
    value: { type: Boolean },
    result: null,
    errors: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  result: DepartmentCsvUploadResult | null;
  errors: DepartmentCsvRowError[];
};

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  title: 'CSVアップロード結果',
  created: '新規登録',
  updated: '名称変更',
  moved: '階層移動',
  skipped: '変更なし',
  detailLabel: '変更の内訳',
  movedWarning:
    'CSVに書かれていない配下の部署も、親と一緒に移動しています。移動前後のフルパスを確認してください。',
  noChanges: '変更はありませんでした。',
  errorIntro: 'エラーのある行があったため、CSVの内容は一件も反映していません。',
  rowLabel: '{row}行目',
});





const hasErrors = computed(() => props.errors.length > 0);

const notices = computed(() => props.result?.notices ?? []);

const hasChanges = computed(() => {
  const result = props.result;
  if (!result) {
    return false;
  }
  return result.created > 0 || result.updated > 0 || result.moved > 0;
});

const counts = computed(() => {
  const result = props.result;
  if (!result) {
    return [];
  }
  return [
    { label: $t(m.created), value: result.created },
    { label: $t(m.updated), value: result.updated },
    { label: $t(m.moved), value: result.moved },
    { label: $t(m.skipped), value: result.skipped },
  ];
});

const formatRowError = (err: DepartmentCsvRowError): string =>
  formatDepartmentCsvRowError(err, (row) =>
    $t(m.rowLabel, { row: String(row) })
  );

const close = () => {
  emit('input', false);
};

return { __sfc: true,$t, m, props, emit, hasErrors, notices, hasChanges, counts, formatRowError, close, sharedMessages }
}

})